module.exports = __webpack_public_path__ + "static/soehne-web-kraftig-37169ac27c20a50138eade6bbc06eb8d.woff";